import React, { Component } from "react";
import { connect } from "react-redux";
import { Container } from "./Container";

import { PasswordInput } from "../molecules";
import { Button } from "../atoms";
import { EditUserController } from "../controllers";

class EditUser extends Container {
	constructor(props) {
		super(props);
		this.state = {
			values: {
				password: "",
				confirmPassword: "",
				oldPassword: "",

			},
			errors: {}
		};
		this.controller = new EditUserController(this);
	}

	render() {
		return (
			<section className="edit-user">
				<div className="header">
					<h1>Senha</h1>
					<form action={this.controller.submit} className="edit-user-container">
							<PasswordInput 
								error={this.state.errors["oldPassword"]} 
								label={"Senha Antiga"} 
								id={"oldPassword"} 
								values={this.state.values.oldPassword} 
								handleChange={this.controller.handleChange} 
							/>
							<PasswordInput 
								error={this.state.errors["password"]} 
								label={"Nova Senha"} 
								id={"password"} 
								values={this.state.values.password} 
								handleChange={this.controller.handleChange} 
							/>
							<PasswordInput 
								label={"Confirmar Senha"} 
								id={"confirmPassword"} 
								values={this.state.values.confirmPassword} 
								handleChange={this.controller.handleChange} 
							/>
							<Button clickAction={this.controller.submit} className="green">ALTERAR SENHA</Button>
					</form>
				</div>
			</section>
		);
	}
}

const map = state => {
	return {
		auth: state.auth.model
	};
};

export default connect(map, null)(EditUser);


// WEBPACK FOOTER //
// src/containers/EditUser.js